import React, { useEffect, useState } from 'react'
import Header from '../../../components/Header'
import { Box, Button, Card, Circle, Flex, Heading, HStack, Spinner, Tag, Text, VStack } from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi'
import { LuBarChart3, LuCalendar, LuClock, LuRefreshCw, LuTrendingDown, LuTrendingUp, LuUsers } from "react-icons/lu";
import { StatCard } from '../../DashboardComponents/StatsCard';

import { BsCheckCircle } from 'react-icons/bs';
import Pagination from 'react-js-pagination';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ExecutionCharts from './ExecutionCharts';
import moment from 'moment';
import { getUserTimeZone } from '../../../utils/DefaultFunction';
const ExecutionReprt = ({ header }) => {

    const { id } = useParams(); // Get id from URL params
   
    const [executions, setExecutions] = useState([]);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalExecutions, setTotalExecutions] = useState(0);
    const [limit] = useState(20);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);
    const [statsLoading, setStatsLoading] = useState(true);
    let [searchParams, setSearchParams] = useSearchParams();
    const getApiHeaders = () => ({
        "x-api-key": localStorage.getItem('api-key'),
        "x-access-token": localStorage.getItem('customer-portal'),
    });
    
    const fetchExecutions = async (page = 1) => {
        try {
            setLoading(true);
            const url = `${process.env.REACT_APP_API_URL}/cohorts/${id}/report/executions?page=${page}&limit=${limit}&order=desc`;

            const response = await fetch(url, {
                method: 'GET',
                headers: getApiHeaders(),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch executions');
            }

            const result = await response.json();

            if (result.success) {
                setExecutions(result.data.executions);
                setData(result.data);
                setTotalExecutions(result.data.pagination.total);
            }
        } catch (err) {
            setError(err.message);
            console.error('Error fetching executions:', err);
        } finally {
            setLoading(false);
        }
    };


    // Fetch Stats
    const fetchStats = async () => {
        try {
            setStatsLoading(true);
            const url = `${process.env.REACT_APP_API_URL}/cohorts/${id}/report/stats`;

            const response = await fetch(url, {
                method: 'GET',
                headers: getApiHeaders(),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch stats');
            }

            const result = await response.json();

            if (result.success) {
                setStats(result.data);
            }
        } catch (err) {
            console.error('Error fetching stats:', err);
        } finally {
            setStatsLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchStats();
            fetchExecutions(currentPage);

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, currentPage]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatDuration = (ms) => {
        return (ms / 1000).toFixed(2) + 's';
    };

    const handleBack = () => {
        navigate(-1)
    }

    const calculateNetChangePercentage = () => {
        if (!stats || !stats.current_contacts || stats.current_contacts === 0) return "0";
        const percentage = ((stats.net_change / (stats.current_contacts - stats.net_change)) * 100).toFixed(1);
        return percentage;
    };

    return (
        <>
            <Header header={header} />

            <Card className='card-style' style={{ margin: "20px 40px" }} shadow={'xl'}>
                <Box p={6} maxW="100%" >
                    <Button
                        leftIcon={<FiArrowLeft />}
                        variant="outline"
                        onClick={handleBack}
                        aria-label="Back to segments"
                        mb={4}
                    >Back To Segments</Button>
                    <Flex justifyContent={"space-between"}>
                        <HStack mb={6}>

                            <VStack align="start" spacing={0}>
                                <Heading size="md">
                                    Segment Execution Report
                                </Heading>
                                <Text color="gray.600" fontWeight={"semibold"}>{searchParams.get("name")}</Text>
                            </VStack>


                        </HStack>
                        {/* <Flex>

                            <Button>TEST</Button>
                            <Button>TEST</Button>


                        </Flex> */}
                    </Flex>

                    {/* Current Contacts Card */}
                    {statsLoading ? (
                        <Flex justify="center" align="center" py={10} bg={"var(--brand-tint)"} borderRadius={"8.75px"}>
                            <Spinner size="md" color="blue.500" />
                        </Flex>
                    ) : stats ? (
                        <Box bg={"var(--brand-tint)"} border={"1px solid var(--brand-tint-strong)"} padding={"10px 20px"} borderRadius={"8.75px"}>
                            <Flex justifyContent={"space-between"} mb={4}>
                                <Text fontSize={"sm"} color={"var(--brand-900)"} fontWeight={"bold"}>
                                    Current Contacts in Segment
                                </Text>
                                <LuUsers style={{ color: "#155dfc", fontSize: "24px" }} />
                            </Flex>

                            <Text fontSize={"4xl"} fontWeight={"bold"} color={"#155dfc"}>
                                {stats.current_contacts.toLocaleString()}
                            </Text>
                            <Text fontSize={"xs"} color={"var(--brand-primary-hover)"}>
                                Last updated:   {moment.utc(stats.last_updated).tz(getUserTimeZone()).format("DD MMM YY hh:mm:ss A")}
                            </Text>
                        </Box>
                    ) : null}

                    {/* Stats Cards */}
                    {statsLoading ? (
                        <Flex justify="center" align="center" py={10}>
                            <Spinner size="lg" color="blue.500" />
                        </Flex>
                    ) : stats ? (
                        <Flex gap={6} wrap="wrap" justifyContent="space-between" my={4}>
                            <StatCard
                                title="Total Executions"
                                value={stats.total_executions.toString()}
                                change="Daily Refresh Rate"
                                icon={<LuRefreshCw />}
                                iconColor="gray.400"
                            // originalValue={stats.total_executions.toString()}
                            />
                            <StatCard
                                title="Contacts Added"
                                value={stats.contacts_added_total.toLocaleString()}
                                change={`Avg ${stats.avg_added_per_execution}/execution`}
                                changeColor="#00a63e"
                                icon={<LuTrendingUp />}
                                iconColor="#00a63e"
                            />
                            <StatCard
                                title="Contacts Removed"
                                value={stats.contacts_removed_total.toLocaleString()}
                                change={`Avg ${stats.avg_removed_per_execution}/execution`}
                                changeColor="#e7000b"
                                icon={<LuTrendingDown />}
                                iconColor="#e7000b"
                            />
                            <StatCard
                                title="Net Change"
                                value={stats.net_change >= 0 ? `+${stats.net_change.toLocaleString()}` : stats.net_change.toLocaleString()}
                                change={`${stats.net_change_percentage || 0}% change`}
                                changeColor="#00a63e"
                                icon={<BsCheckCircle />}
                                iconColor="gray.400"
                            // originalValue="SS"
                            />
                            <StatCard
                                title="Success Rate"
                                value={`${(stats.success_rate * 100).toFixed(1)}%`}
                                change={`Avg time: ${stats.avg_exec_time_sec.toFixed(1)}s`}
                                changeColor="#00a63e"
                                icon={<BsCheckCircle />}
                                iconColor="gray.400"
                            // originalValue="SS"
                            />
                        </Flex>
                    ) : null}


                    <ExecutionCharts cohortId={id} />

                    <Box className="box-style-card" my={4}>
                        <Flex direction="column" mb={4}>
                            <Flex align="center" gap={2}>
                                <LuCalendar size={20} color="#155dfc" />
                                <Text fontSize="md" fontWeight="semibold" color="gray.700">Execution Timeline
                                </Text>
                            </Flex>
                            <Text fontSize="sm" color="#64748b">Detailed history of all segment executions</Text>
                        </Flex>


                        {loading ? (
                            <Flex justify="center" align="center" py={10}>
                                <Spinner size="lg" color="blue.500" />
                            </Flex>
                        ) : error ? (
                            <Box bg="red.50" p={4} borderRadius="md">
                                <Text color="red.600">Error: {error}</Text>
                            </Box>
                        ) : executions.length === 0 ? (
                            <Box bg="gray.50" p={4} borderRadius="md" textAlign="center">
                                <Text color="gray.600">No executions found</Text>
                            </Box>
                        ) : (
                            <VStack spacing={0} align="stretch">
                                {executions.map((execution, index) => (
                                    <Flex key={execution.execution_no} gap={3} align="start">
                                        <Flex direction="column" align="center" gap={2}>
                                            <Circle mt={1} bg={execution.status === 'success' ? '#00a63e' : '#EF4444'} size='12px'>

                                            </Circle>
                                            {/* {index < executions.length - 1 && ( */}
                                            <Box width="2px" flex={1} bg="#0000001a" minHeight="120px" />
                                            {/* )} */}
                                        </Flex>

                                        <Box flex={1} pb={index < executions.length - 1 ? 6 : 0} >
                                            <Flex justify="space-between" align="center" mb={3}>
                                                <Flex align="center" gap={2}>
                                                    <Text fontWeight="semibold" fontSize="sm">
                                                        Execution #{execution.execution_no}
                                                    </Text>
                                                    <Tag
                                                        bg={execution.status === 'success' ? '#dcfce7' : '#fee2e2'}
                                                        fontSize="xs"
                                                        px={2}
                                                        py={1}
                                                        color={execution.status === 'success' ? '#016630' : '#991b1b'}
                                                        border={execution.status === 'success' ? '1px solid #b9f8cf' : '1px solid #fecaca'}
                                                        fontWeight={"semibold"}
                                                        borderRadius={"8.75px"}
                                                    >
                                                        <Flex gap={1} align={"center"}>
                                                            <BsCheckCircle
                                                                size={12}
                                                                color={execution.status === 'success' ? '#22C55E' : '#EF4444'}
                                                                fill={execution.status === 'success' ? '#22C55E' : '#EF4444'}
                                                            />
                                                            <Text textTransform="capitalize">{execution.status}</Text>
                                                        </Flex>
                                                    </Tag>
                                                    <Tag bg={"white"} border={"1px solidrgba(0, 0, 0, 0.03)"} borderRadius={"6.75px"} variant="outline" fontSize="xs" px={2}
                                                        py={1} color={"black"}>
                                                        <LuClock style={{ marginRight: "5px" }} /> {execution.trigger_type}
                                                    </Tag>
                                                </Flex>
                                                <Text fontSize="sm" color="gray.600">
                                                    Execution time
                                                </Text>
                                            </Flex>

                                            <Flex justify="space-between" align="center" mb={4}>
                                                <Text fontSize="xs" color="gray.500">
                                                    {moment.utc(execution.started_at).tz(getUserTimeZone()).format("DD MMM YY hh:mm:ss A")} {execution.execution_no === 1 && `• Triggered by ${data?.created_by}`}
                                                </Text>
                                                {/* <Text fontSize="sm" fontWeight="semibold">
                                                    {formatDuration(execution.duration_ms)}
                                                </Text> */}
                                            </Flex>

                                            <Flex gap={6} bg={"#f1f5f9"} borderRadius={"8.75px"} padding={"14px"}>
                                                <Box flex={1}>
                                                    <Text fontSize="xs" color="gray.500" mb={1}>
                                                        Contacts Added
                                                    </Text>
                                                    <Flex align="center" gap={1}>
                                                        <LuTrendingUp size={14} color="#008236" />
                                                        <Text fontSize="lg" fontWeight="bold" color="#008236">
                                                            {execution.added_count.toLocaleString()}
                                                        </Text>
                                                    </Flex>
                                                </Box>

                                                <Box flex={1}>
                                                    <Text fontSize="xs" color="gray.500" mb={1}>
                                                        Contacts Removed
                                                    </Text>
                                                    <Flex align="center" gap={1}>
                                                        <LuTrendingDown size={14} color="#c10007" />
                                                        <Text fontSize="lg" fontWeight="bold" color="#c10007">
                                                            {execution.removed_count.toLocaleString()}
                                                        </Text>
                                                    </Flex>
                                                </Box>

                                                <Box flex={1}>
                                                    <Text fontSize="xs" color="gray.500" mb={1}>
                                                        Contacts Retained
                                                    </Text>
                                                    <Flex align="center" gap={1}>
                                                        <LuUsers size={14} color="var(--brand-primary-hover)" />
                                                        <Text fontSize="lg" fontWeight="bold" color="var(--brand-primary-hover)">
                                                            {execution.retained_count.toLocaleString()}
                                                        </Text>
                                                    </Flex>
                                                </Box>

                                                <Box flex={1}>
                                                    <Text fontSize="xs" color="gray.500" mb={1}>
                                                        Total Contacts
                                                    </Text>
                                                    <Flex align="center" gap={1}>
                                                        <LuBarChart3 size={14} color="#6B7280" />
                                                        <Text fontSize="lg" fontWeight="bold" color="gray.800">
                                                            {execution.total_contacts.toLocaleString()}
                                                        </Text>
                                                    </Flex>
                                                </Box>
                                            </Flex>
                                        </Box>
                                    </Flex>
                                ))}
                            </VStack>
                        )}

                    </Box>

                    {!loading && !error && totalExecutions > limit && (
                        <Flex justify="center" mt={6}>
                            <Pagination
                                activePage={currentPage}
                                itemsCountPerPage={limit}
                                totalItemsCount={totalExecutions}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                            />
                        </Flex>
                    )}
                </Box>
            </Card>
        </>
    )
}

export default ExecutionReprt